export default [
  {
    header: 'Sign up',
    route: { name: 'user-guideline', params: { page: 'sign-up' } },
  },
  // {
  //   title: 'Overview',
  //   // headers: 'Sign Up',
  //   route: { name: 'user-guideline', params: { page: 'sign-up' } },
  // },
  {
    header: 'Login',
    route: { name: 'user-guideline', params: { page: 'login' } },
  },
  // {
  //   title: 'Overview',
  //   // headers: 'Login',
  //   route: { name: 'user-guideline', params: { page: 'login' } },
  // },
  {
    header: 'Dashboard',
    route: { name: 'user-guideline', params: { page: 'dashboard' } },
  },
  // {
  //   title: 'Overview',
  //   // headers: 'Dashboard',
  //   route: { name: 'user-guideline', params: { page: 'dashboard' } },
  // },
  {
    header: 'Campaign',
  },
  {
    title: 'Create Campaign',
    children: [
      {
        title: 'SMS Broadcast',
        children: [
          {
            title: 'Cost per MSISDN Delivered',
            children: [
              {
                title: 'Create Campaign',
                route: { name: 'user-guideline', params: { page: 'sms-cpd-choose-channel' } },
              },
              {
                title: 'Campaign Type',
                children: [
                  {
                    title: 'Scheduler - Manual',
                    route: { name: 'user-guideline', params: { page: 'sms-cpd-scheduler-manual' } },
                  },
                  {
                    title: 'Scheduler - By Data Visualization',
                    children: [
                      {
                        title: 'Administrative Area',
                        route: { name: 'user-guideline', params: { page: 'sms-cpd-scheduler-dsv-administrative-area' } },
                      },
                      {
                        title: 'User Defined Area',
                        route: { name: 'user-guideline', params: { page: 'sms-cpd-scheduler-dsv-user-defined-area' } },
                      },
                    ],
                  },
                  {
                    title: 'LBA - Manual',
                    route: { name: 'user-guideline', params: { page: 'sms-cpd-lba-manual' } },
                  },
                  {
                    title: 'LBA - By Data Visualization',
                    children: [
                      {
                        title: 'Administrative Area',
                        route: { name: 'user-guideline', params: { page: 'sms-cpd-lba-dsv-administrative-area' } },
                      },
                      {
                        title: 'User Defined Area',
                        route: { name: 'user-guideline', params: { page: 'sms-cpd-lba-dsv-user-defined-area' } },
                      },
                    ],
                  },
                ],
              },
              // {
              //   title: 'Create Campaign Details',
              //   children: [
              //     {
              //       title: 'Set Up Target Audience',
              //       route: { name: 'user-guideline', params: { page: 'sms-cpd-setup-target-audience' } },
              //     },
              //     {
              //       title: 'Upload Target Audience',
              //       route: { name: 'user-guideline', params: { page: 'sms-cpd-upload-target-audience' } },
              //     },
              //   ],
              // },
              // {
              //   title: 'Review & Confirm',
              //   route: { name: 'user-guideline', params: { page: 'sms-cpd-review-confirm' } },
              // },
            ],
          },
          {
            title: 'Cost per Click',
            children: [
              {
                title: 'Create Channel',
                route: { name: 'user-guideline', params: { page: 'sms-cpc-choose-channel' } },
              },
              {
                title: 'Campaign Type',
                children: [
                  {
                    title: 'Scheduler - Manual',
                    route: { name: 'user-guideline', params: { page: 'sms-cpc-scheduler-manual' } },
                  },
                  {
                    title: 'Scheduler - By Data Visualization',
                    children: [
                      {
                        title: 'Administrative Area',
                        route: { name: 'user-guideline', params: { page: 'sms-cpc-scheduler-dsv-administrative-area' } },
                      },
                      {
                        title: 'User Defined Area',
                        route: { name: 'user-guideline', params: { page: 'sms-cpc-scheduler-dsv-user-defined-area' } },
                      },
                    ],
                  },
                  {
                    title: 'LBA - Manual',
                    route: { name: 'user-guideline', params: { page: 'sms-cpc-lba-manual' } },
                  },
                  {
                    title: 'LBA - By Data Visualization',
                    children: [
                      {
                        title: 'Administrative Area',
                        route: { name: 'user-guideline', params: { page: 'sms-cpc-lba-dsv-administrative-area' } },
                      },
                      {
                        title: 'User Defined Area',
                        route: { name: 'user-guideline', params: { page: 'sms-cpc-lba-dsv-user-defined-area' } },
                      },
                    ],
                  },
                ],
              },
              // {
              //   title: 'Create Campaign Details',
              //   children: [
              //     {
              //       title: 'Set Up Target Audience',
              //       route: { name: 'user-guideline', params: { page: 'sms-cpc-setup-target-audience' } },
              //     },
              //     {
              //       title: 'Upload Target Audience',
              //       route: { name: 'user-guideline', params: { page: 'sms-cpc-upload-target-audience' } },
              //     },
              //   ],
              // },
              // {
              //   title: 'Review & Confirm',
              //   route: { name: 'user-guideline', params: { page: 'sms-cpc-review-confirm' } },
              // },
            ],
          },
        ],
      },
      // {
      //   title: 'USSD 747',
      //   children: [
      //     {
      //       title: 'Cost per Sales',
      //       children: [
      //         {
      //           title: 'Choose Channel',
      //           route: { name: 'user-guideline', params: { page: 'ussd-cps-choose-channel' } },
      //         },
      //         {
      //           title: 'Create Campaign Details',
      //           children: [
      //             {
      //               title: 'Set Up Target Audience',
      //               route: { name: 'user-guideline', params: { page: 'ussd-cps-setup-target-audience' } },
      //             },
      //             {
      //               title: 'Upload Target Audience',
      //               route: { name: 'user-guideline', params: { page: 'ussd-cps-upload-target-audience' } },
      //             },
      //           ],
      //         },
      //         {
      //           title: 'Review & Confirm',
      //           route: { name: 'user-guideline', params: { page: 'ussd-cps-review-confirm' } },
      //         },
      //       ],
      //     },
      //   ],
      // },
      {
        title: 'Flash Message',
        children: [
          {
            title: 'Cost per Delivered',
            children: [
              {
                title: 'Create Campaign',
                route: { name: 'user-guideline', params: { page: 'flash-cpd-choose-channel' } },
              },
              {
                title: 'Campaign Type',
                children: [
                  {
                    title: 'Scheduler - Manual',
                    route: { name: 'user-guideline', params: { page: 'flash-cpd-scheduler-manual' } },
                  },
                  {
                    title: 'Scheduler - By Data Visualization',
                    children: [
                      {
                        title: 'Administrative Area',
                        route: { name: 'user-guideline', params: { page: 'flash-cpd-scheduler-dsv-administrative-area' } },
                      },
                      {
                        title: 'User Defined Area',
                        route: { name: 'user-guideline', params: { page: 'flash-cpd-scheduler-dsv-user-defined-area' } },
                      },
                    ],
                  },
                  {
                    title: 'LBA - Manual',
                    route: { name: 'user-guideline', params: { page: 'flash-cpd-lba-manual' } },
                  },
                  {
                    title: 'LBA - By Data Visualization',
                    children: [
                      {
                        title: 'Administrative Area',
                        route: { name: 'user-guideline', params: { page: 'flash-cpd-lba-dsv-administrative-area' } },
                      },
                      {
                        title: 'User Defined Area',
                        route: { name: 'user-guideline', params: { page: 'flash-cpd-lba-dsv-user-defined-area' } },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            title: 'Cost per Click',
            children: [
              {
                title: 'Create Channel',
                route: { name: 'user-guideline', params: { page: 'flash-cpc-choose-channel' } },
              },
              {
                title: 'Campaign Type',
                children: [
                  {
                    title: 'Scheduler - Manual',
                    route: { name: 'user-guideline', params: { page: 'flash-cpc-scheduler-manual' } },
                  },
                  {
                    title: 'Scheduler - By Data Visualization',
                    children: [
                      {
                        title: 'Administrative Area',
                        route: { name: 'user-guideline', params: { page: 'flash-cpc-scheduler-dsv-administrative-area' } },
                      },
                      {
                        title: 'User Defined Area',
                        route: { name: 'user-guideline', params: { page: 'flash-cpc-scheduler-dsv-user-defined-area' } },
                      },
                    ],
                  },
                  {
                    title: 'LBA - Manual',
                    route: { name: 'user-guideline', params: { page: 'flash-cpc-lba-manual' } },
                  },
                  {
                    title: 'LBA - By Data Visualization',
                    children: [
                      {
                        title: 'Administrative Area',
                        route: { name: 'user-guideline', params: { page: 'flash-cpc-lba-dsv-administrative-area' } },
                      },
                      {
                        title: 'User Defined Area',
                        route: { name: 'user-guideline', params: { page: 'flash-cpc-lba-dsv-user-defined-area' } },
                      },
                    ],
                  },
                ],
              },
              // {
              //   title: 'Create Campaign Details',
              //   children: [
              //     {
              //       title: 'Set Up Target Audience',
              //       route: { name: 'user-guideline', params: { page: 'sms-cpc-setup-target-audience' } },
              //     },
              //     {
              //       title: 'Upload Target Audience',
              //       route: { name: 'user-guideline', params: { page: 'sms-cpc-upload-target-audience' } },
              //     },
              //   ],
              // },
              // {
              //   title: 'Review & Confirm',
              //   route: { name: 'user-guideline', params: { page: 'sms-cpc-review-confirm' } },
              // },
            ],
          },
          // {
          //   title: 'Cost per Sales',
          //   children: [
          //     {
          //       title: 'Choose Channel',
          //       route: { name: 'user-guideline', params: { page: 'flash-cps-choose-channel' } },
          //     },
          //     {
          //       title: 'Create Campaign Details',
          //       children: [
          //         {
          //           title: 'Set Up Target Audience',
          //           route: { name: 'user-guideline', params: { page: 'flash-cps-setup-target-audience' } },
          //         },
          //         {
          //           title: 'Upload Target Audience',
          //           route: { name: 'user-guideline', params: { page: 'flash-cps-upload-target-audience' } },
          //         },
          //       ],
          //     },
          //     {
          //       title: 'Review & Confirm',
          //       route: { name: 'user-guideline', params: { page: 'flash-cps-review-confirm' } },
          //     },
          //   ],
          // },
        ],
      },
      // {
      //   title: 'Digiads',
      //   children: [
      //     {
      //       title: 'Cost per Miles',
      //       children: [
      //         {
      //           title: 'Choose Channel',
      //           route: { name: 'user-guideline', params: { page: 'digiads-cpm-choose-channel' } },
      //         },
      //         {
      //           title: 'Create Campaign Details',
      //           children: [
      //             {
      //               title: 'Set Up Target Audience',
      //               route: { name: 'user-guideline', params: { page: 'digiads-cpm-setup-target-audience' } },
      //             },
      //             {
      //               title: 'Upload Target Audience',
      //               route: { name: 'user-guideline', params: { page: 'digiads-cpm-upload-target-audience' } },
      //             },
      //           ],
      //         },
      //         {
      //           title: 'Review & Confirm',
      //           route: { name: 'user-guideline', params: { page: 'digiads-cpm-review-confirm' } },
      //         },
      //       ],
      //     },
      //     {
      //       title: 'Cost per Click',
      //       children: [
      //         {
      //           title: 'Choose Channel',
      //           route: { name: 'user-guideline', params: { page: 'digiads-cpc-choose-channel' } },
      //         },
      //         {
      //           title: 'Create Campaign Details',
      //           children: [
      //             {
      //               title: 'Set Up Target Audience',
      //               route: { name: 'user-guideline', params: { page: 'digiads-cpc-setup-target-audience' } },
      //             },
      //             {
      //               title: 'Upload Target Audience',
      //               route: { name: 'user-guideline', params: { page: 'digiads-cpc-upload-target-audience' } },
      //             },
      //           ],
      //         },
      //         {
      //           title: 'Review & Confirm',
      //           route: { name: 'user-guideline', params: { page: 'digiads-cpc-review-confirm' } },
      //         },
      //       ],
      //     },
      //     {
      //       title: 'Cost per Sales',
      //       children: [
      //         {
      //           title: 'Choose Channel',
      //           route: { name: 'user-guideline', params: { page: 'digiads-cps-choose-channel' } },
      //         },
      //         {
      //           title: 'Create Campaign Details',
      //           children: [
      //             {
      //               title: 'Set Up Target Audience',
      //               route: { name: 'user-guideline', params: { page: 'digiads-cps-setup-target-audience' } },
      //             },
      //             {
      //               title: 'Upload Target Audience',
      //               route: { name: 'user-guideline', params: { page: 'digiads-cps-upload-target-audience' } },
      //             },
      //           ],
      //         },
      //         {
      //           title: 'Review & Confirm',
      //           route: { name: 'user-guideline', params: { page: 'digiads-cps-review-confirm' } },
      //         },
      //       ],
      //     },
      //   ],
      // },
      // {
      //   title: 'bima+',
      //   children: [
      //     {
      //       title: 'Cost per Miles',
      //       children: [
      //         {
      //           title: 'Choose Channel',
      //           route: { name: 'user-guideline', params: { page: 'bimaplus-cpm-choose-channel' } },
      //         },
      //         {
      //           title: 'Create Campaign Details',
      //           children: [
      //             {
      //               title: 'Set Up Target Audience',
      //               route: { name: 'user-guideline', params: { page: 'bimaplus-cpm-setup-target-audience' } },
      //             },
      //             {
      //               title: 'Upload Target Audience',
      //               route: { name: 'user-guideline', params: { page: 'bimaplus-cpm-upload-target-audience' } },
      //             },
      //           ],
      //         },
      //         {
      //           title: 'Review & Confirm',
      //           route: { name: 'user-guideline', params: { page: 'bimaplus-cpm-review-confirm' } },
      //         },
      //       ],
      //     },
      //     {
      //       title: 'Cost per Click',
      //       children: [
      //         {
      //           title: 'Choose Channel',
      //           route: { name: 'user-guideline', params: { page: 'bimaplus-cpc-choose-channel' } },
      //         },
      //         {
      //           title: 'Create Campaign Details',
      //           children: [
      //             {
      //               title: 'Set Up Target Audience',
      //               route: { name: 'user-guideline', params: { page: 'bimaplus-cpc-setup-target-audience' } },
      //             },
      //             {
      //               title: 'Upload Target Audience',
      //               route: { name: 'user-guideline', params: { page: 'bimaplus-cpc-upload-target-audience' } },
      //             },
      //           ],
      //         },
      //         {
      //           title: 'Review & Confirm',
      //           route: { name: 'user-guideline', params: { page: 'bimaplus-cpc-review-confirm' } },
      //         },
      //       ],
      //     },
      //   ],
      // },
      // {
      //   title: 'In Browser Notification',
      //   children: [
      //     {
      //       title: 'Cost per Miles',
      //       children: [
      //         {
      //           title: 'Choose Channel',
      //           route: { name: 'user-guideline', params: { page: 'ibn-cpm-choose-channel' } },
      //         },
      //         {
      //           title: 'Create Campaign Details',
      //           children: [
      //             {
      //               title: 'Set Up Target Audience',
      //               route: { name: 'user-guideline', params: { page: 'ibn-cpm-setup-target-audience' } },
      //             },
      //             {
      //               title: 'Upload Target Audience',
      //               route: { name: 'user-guideline', params: { page: 'ibn-cpm-upload-target-audience' } },
      //             },
      //           ],
      //         },
      //         {
      //           title: 'Review & Confirm',
      //           route: { name: 'user-guideline', params: { page: 'ibn-cpm-review-confirm' } },
      //         },
      //       ],
      //     },
      //     {
      //       title: 'Cost per Click',
      //       children: [
      //         {
      //           title: 'Choose Channel',
      //           route: { name: 'user-guideline', params: { page: 'ibn-cpc-choose-channel' } },
      //         },
      //         {
      //           title: 'Create Campaign Details',
      //           children: [
      //             {
      //               title: 'Set Up Target Audience',
      //               route: { name: 'user-guideline', params: { page: 'ibn-cpc-setup-target-audience' } },
      //             },
      //             {
      //               title: 'Upload Target Audience',
      //               route: { name: 'user-guideline', params: { page: 'ibn-cpc-upload-target-audience' } },
      //             },
      //           ],
      //         },
      //         {
      //           title: 'Review & Confirm',
      //           route: { name: 'user-guideline', params: { page: 'ibn-cpc-review-confirm' } },
      //         },
      //       ],
      //     },
      //   ],
      // },
    ],
  },
  {
    title: 'Manage Campaign',
    children: [
      {
        title: 'Campaign List',
        route: { name: 'user-guideline', params: { page: 'manage-campaign-list' } },
      },
      {
        title: 'Campaign Detail',
        route: { name: 'user-guideline', params: { page: 'manage-campaign-detail' } },
      },
    ],
  },
  {
    header: 'Report',
    route: { name: 'user-guideline', params: { page: 'report' } },
  },
  // {
  //   title: 'Overview',
  //   route: { name: 'user-guideline', params: { page: 'report' } },
  // },

  // FINANCE
  // {
  //   header: 'Finance',
  // },
  // {
  //   title: 'TOP UP Credit',
  //   route: { name: 'user-guideline', params: { page: 'topup-credit' } },
  // },
  // {
  //   title: 'TOP UP Detail',
  //   route: { name: 'user-guideline', params: { page: 'topup-detail' } },
  // },
  // {
  //   title: 'TOP UP Success',
  //   route: { name: 'user-guideline', params: { page: 'topup-success' } },
  // },
  // {
  //   title: 'Ad Budget History',
  //   route: { name: 'user-guideline', params: { page: 'ad-budget-history' } },
  // },
  // END FINANCE


  // ACCOUNT
  {
    header: 'Account',
  },
  // MY COMPANY
  {
    title: 'My Company',
    route: { name: 'user-guideline', params: { page: 'account-mycompany' } },
  },
  // END MY COMPANY
  // MY ACCOUNT
  {
    title: 'My Account',
    route: { name: 'user-guideline', params: { page: 'account-myaccount' } },
  },
  // END MY ACCOUNT
  // END ACCOUNT

  // INBOX
  {
    header: 'Inbox',
    route: { name: 'user-guideline', params: { page: 'inbox' } },
  },
  // END INBOX

  // {
  //   title: 'Overview',
  //   route: { name: 'user-guideline', params: { page: 'inbox' } },
  // },

  // SUPPORT
  {
    header: 'Support',
    route: { name: 'user-guideline', params: { page: 'support' } },
  },
  // End SUPPORT

  // {
  //   title: 'Overview',
  //   route: { name: 'user-guideline', params: { page: 'support' } },
  // },
]
